import diseasesConditions from './parents-diseasesConditions.json';
import doctorsHospitals from './parents-doctorsHospitals.json';
import emotionsBehavior from './parents-emotionsBehavior.json';
import firstAidSafety from './parents-firstAidSafety.json';
import generalHealth from './parents-generalHealth.json';
import growthDevelopment from './parents-growthDevelopment.json';
import infections from './parents-infections.json';
import nutritionExercise from './parents-nutritionExercise.json';
import playLearn from './parents-playLearn.json';
import pregnancyBaby from './parents-pregnancyBaby.json';
import schoolFamily from './parents-schoolFamily.json';

export const parents = { diseasesConditions, doctorsHospitals, emotionsBehavior, firstAidSafety, generalHealth, growthDevelopment, infections, nutritionExercise, playLearn, pregnancyBaby, schoolFamily };
